import React from 'react';
import { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
  setSelectedCar,
  setSelectedPackage,
  setServicePackageState,
} from '../../../store/servicePackage/actions';
import eventTypeCarCoupon from 'ui/lib/gtm/eventTypeCarCoupon';
import eventViewServicePDP from 'ui/lib/gtm/eventViewServicePDP';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

export interface IServiceProduct {
  vehicleName: string;
  vehicleCode: string;
  couponServices: { code: string }[];
  servicePackage?: { code: string }[];
}

export interface IServiceProductServicePackage {
  vehicleName: string;
  vehicleCode: string;
}

export interface IServiceContent {
  couponCode?: string;
  imageUrl?: string;
  couponPacketServiceContent: {
    carCategory: string;
    titleInformationBelow: string;
    descriptionInformationBelow: string;
    titleFaq: string;
    titlePage?: string;
    descriptionPage?: string;
    carModel?: string;
    imageUrl?: string;
  };
}

interface TypeCarModalProps {
  serviceProductList?: IServiceProduct[];
  setViewTypeCar: (value: boolean) => void;
  serviceType: string;
  serviceContent?: IServiceContent;
  titleCoupon?: string;
  bodyTypeName: string;
  serviceProductTitle: string;
  triggerGTM?: { status: boolean };
}

const TypeCarModal = ({
  serviceProductList = [],
  setViewTypeCar,
  serviceType,
  bodyTypeName,
  serviceProductTitle,
  // serviceContent,
  // titleCoupon,

  triggerGTM = { status: false },
}: TypeCarModalProps) => {
  const dispatch = useDispatch();

  const router = useRouter();
  const { selectedPackage, selectedCar } = useSelector((state: any) => state.servicePackage);
  const { categoryService } = useSelector((state: any) => state.dataGTM || {});

  const [selectedType, setSelectedType] = useState(selectedCar?.transmission); // A/T or M/T

  // Filter car list to show based on selected transmission tab
  const shownCarList = useMemo(() => {
    return serviceProductList.filter((car: any) => car?.transmission === selectedType);
  }, [serviceProductList, selectedType]);

  const handleSelectCar = (selectedCar) => {
    const { carCategory, productCode } = router.query;
    if (triggerGTM?.status) {
      eventViewServicePDP(
        {
          name: serviceProductTitle?.toLowerCase() || 'not available',
          id: serviceProductTitle?.toLowerCase() || 'not available',
          price: Math.floor(
            selectedPackage?.strikeThroughPrice?.value || selectedPackage?.price?.value || 0
          ),
          brand: 'toyota',
          category: !bodyTypeName
            ? 'not available'
            : bodyTypeName.toLowerCase() === 'commercial'
              ? 'komersial'
              : bodyTypeName?.toLowerCase(),
          variant: selectedPackage?.name?.toLowerCase() || 'not available',
          discountedPrice: Math.floor(
            selectedPackage?.price?.value - selectedPackage?.strikeThroughPrice?.value || 0
          ),
        },
        selectedCar?.vehicleName?.toLowerCase(),
        serviceType,
        categoryService
      );
    }

    dispatch(setSelectedCar(selectedCar));
    if (serviceType === 'coupon') {
      dispatch(setSelectedPackage(selectedCar?.couponServices[0] || {}));
      const redirectPath = `/${carCategory}/${productCode}/${selectedCar?.couponServices?.[0]?.code.toLowerCase()}/?vehicleCode=${selectedCar.vehicleCode.toLowerCase()}`;
      router.push(redirectPath);
    }
    eventTypeCarCoupon(categoryService, serviceProductTitle, selectedCar?.vehicleName, serviceType);

    // Set default package of a car (default service coupon is handled in page level when initial load)
    if (serviceType === 'package') {
      dispatch(setSelectedPackage(selectedCar?.servicePackage[0] || {}));
      dispatch(
        setServicePackageState({
          field: 'isShowBaseModel',
          value: false,
        })
      );
    }

    setViewTypeCar(false);
  };

  return (
    <div className="container px-0">
      <div className="flex justify-center items-start w-full max-w-[1023px] h-[42px] mb-4 bg-reliableBlack5 p-1 rounded-lg lg:max-w-[480px] lg:h-[46px]">
        {serviceProductList.some((car: any) => car?.transmission === 'M/T') && (
          <button
            className={`w-full h-full text-base flex justify-center items-center rounded transition-colors duration-200 
            ${serviceProductList.some((car: any) => car?.transmission === 'A/T') ? 'max-w-[480px] lg:max-w-[232px]' : 'max-w-[512px] lg:max-w-[480px]'} 
            ${selectedType === 'M/T' ? 'bg-supportiveRed text-white' : 'bg-transparent text-reliableBlack'}`}
            onClick={() => setSelectedType('M/T')}
          >
            Manual
          </button>
        )}
        {serviceProductList.some((car: any) => car?.transmission === 'A/T') && (
          <button
            className={`w-full h-full text-base flex justify-center items-center rounded transition-colors duration-200 
            ${serviceProductList.some((car: any) => car?.transmission === 'M/T') ? 'max-w-[480px] lg:max-w-[232px]' : 'max-w-[512px] lg:max-w-[480px]'} 
            ${selectedType === 'A/T' ? 'bg-supportiveRed text-white' : 'bg-transparent text-reliableBlack'}`}
            onClick={() => setSelectedType('A/T')}
          >
            Automatic
          </button>
        )}
      </div>

      <ul className="text-left max-h-[calc(100vh-150px)] lg:max-h-[400px] overflow-y-auto custom-scrollbar">
        {shownCarList.map((car, index) => (
          <li
            className={`text-base text-reliableBlack border-b border-gray-300 cursor-pointer hover:bg-gray-100 py-4 pl-4 ${car?.vehicleCode === selectedCar.vehicleCode ? ' bg-gray-100' : ''}`}
            key={index}
            onClick={() => handleSelectCar(car)}
          >
            {car.vehicleName}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default TypeCarModal;
